import React, { useState } from 'react';
import { Form, Input, Button, message, Radio } from 'antd';

import {callApi} from '../../helpers/Api';

const Report = (props) => {
    const [value, setValue] = useState('');
    // const [type, setType] = useState(null);

    const [form] = Form.useForm();
    const inputStyle = {marginBottom: '0'}

    const onChange = (e) => {
        // setType(e.target.value);
        setValue(e.target.value);
    }

    const handleSubmit = (e) => {
        e.preventDefault()

        callApi('/api/report_story/', {
            method: 'POST',
            body: JSON.stringify({
                story_uuid: props.storyUuid,
                type: value,
            }),
        })
        .then(json => {
            if(json[0].success)
                message.success(
                    <p style={{display: 'inline-block'}}>Reported!</p>
                );
        })

        form.resetFields();
        props.close();
    }

    const radioStyle = {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
    };

    return (
        <Form form={form} layout='vertical'>
            <p className="text-darkable">Encountered a bug or have an idea for a new feature? Let us know!</p>
            <Radio.Group onChange={onChange} value={value}>
                <Radio style={radioStyle} value={'Sexual content'}>
                    Sexual content
                </Radio>
                <Radio style={radioStyle} value={'Violent or repulsive content'}>
                    Violent or repulsive content
                </Radio>
                <Radio style={radioStyle} value={'Hateful or abusive content'}>
                    Hateful or abusive content
                </Radio>
                <Radio style={radioStyle} value={'Harmful or dangerous acts'}>
                    Harmful or dangerous acts
                </Radio>
                <Radio style={radioStyle} value={'Child abuse'}>
                    Child abuse
                </Radio>
                <Radio style={radioStyle} value={'Promotes terrorism'}>
                    Promotes terrorism
                </Radio>
                <Radio style={radioStyle} value={'Spam or misleading'}>
                    Spam or misleading
                </Radio>
                <Radio style={radioStyle} value={'Infringes my rights'}>
                    Infringes my rights
                </Radio>
                {/* <Radio style={radioStyle} value={'other'}>
                    Other...
                    {value === 'other' ? <Input value={} onChange={} style={{ width: 100, marginLeft: 10 }} /> : null}
                </Radio> */}
            </Radio.Group>
            <br />
            <br />
            <br />
            <Form.Item style={inputStyle} >
                <Button block type="primary" htmlType="submit" onClick={handleSubmit}>report</Button>
            </Form.Item>
        </Form>
    );
}

export default Report;